import { defineMessages } from 'react-intl';

export default defineMessages({
  scheduleTabLabel: {
    id: 'venue-pages.autosync.changelog.schedule-tab-label',
    defaultMessage: 'Schedule',
  },
  instructorTabLabel: {
    id: 'venue-pages.autosync.changelog.instructors-tab-label',
    defaultMessage: 'Staff',
  },
  classDescriptionTabLabel: {
    id: 'venue-pages.autosync.changelog.classes-tab-label',
    defaultMessage: 'Class',
  },
  userSource: {
    id: 'venue-pages.autosync.changelog.user-source',
    defaultMessage: '{userSource, select, dashboard {Partner} other {AutoSync}}',
  },
  action: {
    id: 'venue-pages.autosync.changelog.action',
    defaultMessage:
      '<strong>{actionType, select, create {Added} update {Updated} delete {Removed} other {Pending}}</strong> {actionTime}',
  },
  noUpdates: {
    id: 'venue-pages.autosync.changelog.no-updates',
    defaultMessage: 'No Updates',
  },
  updateHistory: {
    id: 'venue-pages.autosync.changelog.update-history',
    defaultMessage: 'Update History',
  },
  fetchMsiChangelogError: {
    id: 'venue-pages.autosync.changelog.request-error',
    defaultMessage: 'There was a problem fetching the changelog',
  },
});
